import { render, staticRenderFns } from "./investorQuestions.vue?vue&type=template&id=32c4ce56"
import script from "./investorQuestions.vue?vue&type=script&lang=js"
export * from "./investorQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports